import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/kinetic-flux-logo-thumbnail.svg';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="logo">
          <img src={logo} alt="Kinetic Flux Logo" width="38" height="38" decoding="async" />
        </Link>
        <div 
          className={`nav-toggle ${isOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeMenu} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
          <li><Link to="/work" onClick={closeMenu} className={location.pathname === '/work' ? 'active' : ''}>Work</Link></li>
          <li><Link to="/services" onClick={closeMenu} className={location.pathname.startsWith('/services') ? 'active' : ''}>Services</Link></li>
          <li><Link to="/about" onClick={closeMenu} className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/blog" onClick={closeMenu} className={location.pathname.startsWith('/blog') ? 'active' : ''}>Blog</Link></li>
          <li><a href="https://games.kineticflux.net" onClick={closeMenu}>Games</a></li>
          <li><Link to="/contact" onClick={closeMenu} className="nav-cta">Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
